import * as React from 'react';
import { get, sortBy } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

export default [
  {
    label: 'Jméno',
    field: 'label',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Počet týdnů',
    field: 'weeksNumber',
    type: ColumnType.NUMBER,
    width: 200
  },
  {
    label: 'Týdny',
    field: 'weekItems',
    type: ColumnType.JSX,
    jsx: ({ row }) => {
      return (
        <div style={{ whiteSpace: 'nowrap', display: 'flex' }}>
          {sortBy(get(row, 'weekItems', []), ['order']).map((weekObject: any) => (
            <div key={weekObject.id} style={{ marginRight: 10, marginBottom: 16 }}>
              <div style={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>{get(weekObject, 'week.label')}</div>
              {sortBy(get(weekObject, 'week.weekDays', []), ['order']).map((dayObject: any) => (
                <span
                  key={get(dayObject, 'id')}
                  style={{
                    borderBottom: `5px solid ${get(dayObject, 'day.color', 'transparent')}`,
                    padding: `0 5px`
                  }}
                >
                  {get(dayObject, 'day.label')}
                </span>
              ))}
            </div>
          ))}
        </div>
      );
    }
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-templates/calendars/_calendarsColumns.tsx